define('constants/closeAccountConstants',[], function() {
    return {
        reasons: {
            lacksFeatures: "1",
            tooDifficult: "2",
            tooExpensive: "3",
            billingProblem: "4",
            technicalProblem: "5",
            poorCustomerService: "6",
            noLongerNeeded: "7",
            fraud: "8",
            termsOfUseViolation: "9",
            other: "10",
            writtenRequest: "11",
            nonPayment: "12",
            portOut: "13",
            notEnoughCalls: "14",
            liveReceptionistIssue: "15"
        },
        noLongerNeededReasons: {
            temporaryCampaign: 1,
            noLongerInBusiness: 2,
            notUsingIt: 3,
            other: 4
        },
        tooExpensiveReasons: {
            notGoodValue: 1,
            taxesAndFeesTooHigh: 2,
            other: 3
        },
        lacksFeaturesOptions: {
            analyticsAndReporting: 1,
            callQueues: 2,
            conferencing: 3,
            contactManagement: 4,
            dataCalling: 5,
            faxing: 6,
            holdTransfer: 7,
            international: 8,
            ipPhones: 9,
            screenSharing: 10,
            videoCalling: 11,
            webCalling: 12,
            webMessaging: 13,
            aiAnswering: 14,
            spamBlocking: 15,
            enhancedDataAnalytics: 16,
            integrations: 17,
            afterHoursTracking: 18,
            scriptEditing: 19,
            other: 99
        },
        liveReceptionistIssueOptions: {
            callsLastedTooLong: 1,
            receptionistQualityInconsistent: 2,
            receptionistsCouldNotAnswerEnoughQuestionsOrPerformTasks: 3,
            receptionistsCouldNotFollowScripts: 4,
            receptionistsNotFriendly: 5,
            tooManyErrors: 6,
            tooManyHangupsSpamCalls: 7,
            waitTimesTooLong: 8,
            other: 99
        }
    };
});

